import { JobClassAmount } from './job-class-amount.model';

export interface JobClassDesignation {
  Name: string;
  JobClassAndAmounts: Array<JobClassAmount>;
}
